export default {
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
  FORCE_CHANGE_PASSWORD: '/auth/change-password',

  FACILITY: '/facility',
  ACCOUNT: '/account',
  ACCOUNT_REGISTER: '/account/register',
  ACCOUNT_DETAIL: '/account/:id',
  POLICY: '/pre-registration/policy/:tenantKey',
  PRE_REGISTER_CAMERA: '/pre-registration/face-photo-shoot',
  LOW_QUALITY_FACE_PHOTO: '/pre-registration/low-quality',
  REGISTER_TEMP: '/pre-registration/register',
  REGISTER_COMPLETE: '/pre-registration/complete',

  DASHBOARD: '/home/dashboard',
  PRE_REGISTRATION_DETAIL: '/home/pre-registration/:id',
  PRE_REGISTRATION_LIST: '/home/pre-registration',
  DRIVER_MANAGEMENT: '/home/driver-management',
  DRIVER_MANAGEMENT_DETAIL: '/home/driver-management/:id',
  RECEPTION_HISTORY: '/home/reception-history',
  DRIVER_REGISTER_HOME: '/home/driver-register',
  DAILY_REPORT: '/home/reception-history/daily-report',
  SYSTEM_CONFIGURATION: '/home/system-configuration',
  SETTING_SMS: '/home/system-configuration/setting-sms',
  CHANGE_PASSWORD: '/home/change-password',
  NOTIFICATION_LIST: '/home/notification-list',

  DRIVER_REGISTER: '/driver-register',
  DRIVER_REGISTER_SUCCESS: '/driver-register/success',

  SECURITY_BOX: '/home/security-box',

  VERIFY_PHONE_DRIVER: '/verify/:type/:hashId',
  VERIFY_PHONE_DRIVER_TMP: '/verify/:type/:hashId',
};
